type Msg = Message & {sent: boolean, showSender: boolean}
type MessageProps = {id?: string, status: Message["status"], timestamp?: number};
export type GroupResult = {
    messages: Record<string, Msg[]>,
    lastUnreadId?: string
    lastDate?: string
};
export type MessageGroup = {label: string, items: Msg[]};
export interface Message {
    id: string
    chatID: string
    content: string
    readers: string[]
    read?: boolean
    timestamp: number
    senderId: string
    senderName: string
    status: "pending" | "sent" | "read" | "failed"
}

type Chat = {
    id: string;
    loadID?: number;
    messages: Message[];
    createdAt: string;
    status?: "active" | "archived"
}

export type  Participant =
| {type: "onboarded", data: {
    role: "sender" | "recipient" | "approver" | string;
    name: string;
    phone?: string;
    email: string;
    profileImage?: string
}}
| {type: "non-existent", data: {email: string}};

// Model used for grouping messages in chat window
export type MessageItem =
| { type: "date"; label: string }
| { type: "unread"; count: number }
| { type: "message"; data: Message };

function reducer(acc: Record<string, Chat>, val: Chat): Record<string,Chat>{
    if (!acc[val.id]) {
        acc[val.id] = val;
    }
    return acc;
}

function messageReducer(acc: Record<string, Message>, val: Message): Record<string, Message> {
    if (!acc[val.id]) {
        acc[val.id] = val;
    }
    return acc;
}

const Chat = {
    addMessages(c: Chat, m: Message[]): Chat {
        const clone = Object.assign({}, c);
        let messages = clone.messages.reduce(messageReducer, Object.create(null));
        messages = m.reduce(messageReducer, messages);
        clone.messages = Object.values(messages);
        return clone;
    },
    acknowledgeMessages(c: Chat, reader: string, ids: string[]): Chat {
        const clone = Object.assign({}, c);
        clone.messages = clone.messages.map(function (m) {
            let readers = m.readers;
            if (ids.includes(m.id)) {
                readers = readers.concat([reader]);
            }
            m.readers = readers;
            return m;
        });
        return clone;
    },
    mergeChats(c1: Chat[], c2: Chat[]): Chat[] {
        let result = c1.reduce(reducer, Object.create(null));
        result = c2.reduce(reducer, result);
        return Object.values(result);
    },
    updateMessage(c: Chat, val: MessageProps, id: string): Chat {
        const clone = Object.assign({}, c);
        clone.messages = clone.messages.map(function (m) {
            let m2 = Object.assign({}, m);
            if (m.id === id) {
                Object.assign(m2, val);
            }
            return m2;
        });
        return clone;
    }
};

const Participant = {
    summarize(count: number): string {
        const total = count - 1;
        return `You & ${total} participant${total > 1 ? "s" : ""}`;
    }
};

export {Chat, Participant};
